import { Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

const Nav = () => {
    return (
        <Box 
            style={{position: "fixed",
                bottom: "0px",
                left: "0px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "end",
                height: "10vh",
            }}
            sx={{
                width: {
                  xs: '90vw', // 0px and up (mobile)
                  sm: '60vw',  // 600px and up
                  md: '40vw',  // 900px and up
                  lg: '30vw',  // 1200px and up
                  xl: '20vw'   // 1536px and up
                },
              }}
        >
            <Link to="/">
                <Button sx={{fontSize: {xs: "0.75em", sm: "0.85em"},  padding: "4px 8px"}}>
                    Home
                </Button>
            </Link>
            <Link to="/privacy">
                <Button sx={{fontSize: {xs: "0.75em", sm: "0.85em"},  padding: "4px 8px"}}>
                    Privacy Policy
                </Button>
            </Link>
            <Link to="/terms">
                <Button sx={{fontSize: {xs: "0.75em", sm: "0.85em"},  padding: "4px 8px"}}>
                    Terms of Service
                </Button>
            </Link>
        </Box>
    )
};

export default Nav;